import { faPen } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { formatCurrencyWithDecimal } from "common/utils/currency"
import { DEFAULT_CURRENCY_SYMBOL } from "features/Contactos/constants/index"
import {
  getNewDocumentCurrency,
  newDocumentoSettingsSelector,
} from "features/Crear/redux/selectors/newDocumentoSettingsSelectors"
import { useTaxes } from "features/User/pages/Taxes/useTaxes"
import { find, sumBy } from "lodash"
import { nanoid } from "nanoid"
import React from "react"
import { useTranslation } from "react-i18next"
// eslint-disable-next-line no-restricted-imports
import { useDispatch, useSelector } from "react-redux"
import { useCurrency } from "../../../../common/hooks/useCurrency"
import {
  setShowDescuentoModal,
  setShowRetencionModal,
} from "../../redux/slices/newDocumentoSettingsSlice"
import {
  getImpuestoCondition,
  handleJoinDuplicates,
  handleUpdateImpuestoShape,
} from "../ConceptosTable/utils"

const DocumentoFormTotales = ({
  documento,
  conceptos,
  isFacturaRecurrente = false,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  const { taxesDefault } = useTaxes()
  // @ts-expect-error TS(2339): Property 'global' does not exist on type 'DefaultR...
  const { tiposImpuestosGenerales } = useSelector((state) => state.global)
  const currency = useSelector(getNewDocumentCurrency)
  const { showDescuento, showRetencion } = useSelector(
    newDocumentoSettingsSelector
  )
  // @ts-expect-error TS(2339): Property 'documentos' does not exist on type 'Defa...
  const { facturaRecurrente } = useSelector((state) => state.documentos)
  const { currencyList } = useCurrency()
  const currencyData = currencyList?.find(
    ({ abreviatura }) => abreviatura === currency
  )
  const valorTotal = sumBy(conceptos, "impuesto")

  const impuestosTotales = handleJoinDuplicates(
    conceptos,
    getImpuestoCondition,
    handleUpdateImpuestoShape
  )

  return (
    <div className='col-lg-6 justify-content-end'>
      <div className='row justify-content-end'>
        <div className='text-right col-5'>
          {t("crear.facturaRec.taxableAmountLabel")}
        </div>

        <div className='text-right col-5'>
          {`${formatCurrencyWithDecimal(documento.subtotal)?.replace(
            DEFAULT_CURRENCY_SYMBOL,
            ""
            // @ts-expect-error TS(2339): Property 'simbolo' does not exist on type 'never'.
          )} ${currencyData?.simbolo}`}
        </div>
      </div>

      {showDescuento && (
        <div className='row align-items-center justify-content-end'>
          <div className='text-right col-5'>
            {t("crear.facturaRec.discountLabel")}
            {documento.descuento}%:
          </div>
          <div className='text-right col-5 position-relative'>
            -
            {`${formatCurrencyWithDecimal(documento.totalDescuento)?.replace(
              DEFAULT_CURRENCY_SYMBOL,
              ""
              // @ts-expect-error TS(2339): Property 'simbolo' does not exist on type 'never'.
            )} ${currencyData?.simbolo}`}
            <FontAwesomeIcon
              className='absolute w-2 ml-1'
              // @ts-expect-error TS(2345): Argument of type...
              onClick={() => dispatch(setShowDescuentoModal(true))}
              icon={faPen}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
      )}
      <div className='row align-items-center justify-content-end'>
        {impuestosTotales?.map(
          ({
            totalImpuesto,
            impuestoArticuloPorcentaje,
            impuestoArticuloTipoId,
          }: $TSMigrationFixMe) => {
            const foundTax = find(taxesDefault, ["id", impuestoArticuloTipoId])
            return (
              <React.Fragment key={nanoid()}>
                <div className='text-right col-5 align-items-center'>
                  {
                    // @ts-expect-error TS(2339): Property 'grupoImpuesto' does not exist on type 'n...
                    foundTax?.grupoImpuesto?.categoria
                  }{" "}
                  ({impuestoArticuloPorcentaje}%):
                </div>

                <div className='text-right col-5'>
                  {`${formatCurrencyWithDecimal(totalImpuesto)?.replace(
                    DEFAULT_CURRENCY_SYMBOL,
                    " "
                    // @ts-expect-error TS(2339): Property 'simbolo' does not exist on type 'never'.
                  )} ${currencyData?.simbolo}`}
                </div>
              </React.Fragment>
            )
          }
        )}
      </div>

      {showRetencion && (
        <div className='row align-items-center justify-content-end'>
          <div className='text-right col-5 align-items-center'>
            <span>
              {!isFacturaRecurrente
                ? find(tiposImpuestosGenerales, [
                    "id",
                    String(documento.retencionTipoId),
                  ])?.grupoImpuesto.categoria
                : facturaRecurrente.impuestoRetenido}
              {} (
              {documento.retencionPorcentaje ||
                facturaRecurrente.tarifaImpuesto}
              %):
            </span>
          </div>

          <div className='text-right col-5 position-relative'>
            {`${
              formatCurrencyWithDecimal(
                documento.totalRetencion || documento.retenecionRecurrente
              )?.replace(DEFAULT_CURRENCY_SYMBOL, "") || "0,00"
              // @ts-expect-error TS(2339): Property 'simbolo' does not exist on type 'never'.
            } ${currencyData?.simbolo}`}
            <FontAwesomeIcon
              className='absolute w-2 ml-1'
              // @ts-expect-error TS(2345): Argument of type...
              onClick={() => dispatch(setShowRetencionModal(true))}
              icon={faPen}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
      )}

      <div className='mt-2 mb-5 row align-items-center justify-content-end'>
        <div className='text-right col-5 font-weight-bold'>
          {t("crear.facturaRec.totalLabel")}
        </div>
        <div className='text-right col-5 font-weight-bold'>
          {`${formatCurrencyWithDecimal(
            valorTotal +
              documento.subtotal -
              documento.totalDescuento -
              (documento.totalRetencion || documento.retenecionRecurrente
                ? Math.abs(
                    documento.totalRetencion || documento.retenecionRecurrente
                  )
                : 0)
            // @ts-expect-error TS(2339): Property 'simbolo' does not exist on type 'never'.
          )?.replace(DEFAULT_CURRENCY_SYMBOL, "")} ${currencyData?.simbolo}`}
        </div>
      </div>
    </div>
  )
}

export default DocumentoFormTotales
